import { PermissionLevel } from './permission-level.enum';

export enum PermissionType {
  User = 'user',
  Group = 'group',
}
/**
 * Represents a permission for a property set.
 */
export interface PropertySetPermission {
  /**
   * The ID of the permission.
   */
  id: number;
  /**
   * The Property Set ID of the permission.
   */
  entity_id: number;
  /**
   * The entity type associated with the permission.
   * For now, it is limited to "property-sets".
   */
  entity_type?: string;
  /**
   * The type of permission.
   * It can be either "user" or "group".
   */
  type: PermissionType | string;
  /**
   * The level of permission.
   * It can be 1 (read), 2 (write), or 3 (admin).
   */
  level: PermissionLevel;
  /**
   * The MIQ user id associated with the permission.
   * This is applicable when the permission_type is "user".
   */
  user_id: number;
  /**
   * The MIQ user email associated with the permission.
   */
  user_email: string;
  /**
   * The MIQ user full name associated with the permission.
   */
  user_name: string;
  /**
   * The MIQ user role id associated with the permission.
   */
  role_id: number;
  /**
   * The MIQ user role desc associated with the permission.
   *    * This is applicable when the permission_type is "group".
   */
  role_desc?: string;
  /**
   * The MIQ user region id  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  region_id: number;
  /**
   * The MIQ user region desc  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  region_desc: string;
  /**
   * The MIQ user devision id  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  division_id: number;
  /**
   * The MIQ user devision desc  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  division_desc: string;
  /**
   * The MIQ user market id  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  market_id: number;
  /**
   * The MIQ user market desc  associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  market_desc: string | null;
  /**
   * The MIQ user usage type associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  usage_type_id: number | null;
  /**
   * The MIQ user confidentiality associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  confidentiality_type_id: number | null;
  /**
   * The MIQ user skey associated with the permission.
   * This is applicable when the permission_type is "user".
   */
  miq_user_skey?: string;
  /**
   * The MIQ role type skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  miq_role_type_skey?: string;
  /**
   * The global region skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  global_region_skey?: string;
  /**
   * The division skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  division_skey?: string;
  /**
   * The market skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  market_skey?: string;
  /**
   * The property usage type skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  property_usage_type_skey?: string;
  /**
   * The confidentiality type skey associated with the permission.
   * This is applicable when the permission_type is "group".
   */
  confidentiality_type_skey?: string;
}
